import React from 'react';
import { getComplianceFindingApiService, IEvent } from 'common/module_interface/events/Events';
import { ComplianceFindingClose } from 'common/module_interface/events/complianceFindingApi.interface';

export interface UseDeleleEventRequest {
    onSuccess?: (response: ComplianceFindingClose.Response) => void;
    onError?: (error: string) => void;
}

export interface UseDeleleEventPayload {
    isLoading: boolean;
    isError: boolean;
    results?: ComplianceFindingClose.Response;

    deleteEvents: (events: IEvent[]) => Promise<void>;
    reset?: () => void;
}

export type UseDeleleEventReset = (req?: UseDeleleEventRequest) => UseDeleleEventPayload;

export const useDeleteEvent: UseDeleleEventReset = (req) => {
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [isError, setIsError] = React.useState<boolean>(false);
    const [results, setResults] = React.useState<ComplianceFindingClose.Response>();

    const deleteEvents = React.useCallback(
        async (events: IEvent[]) => {
            setIsError(false);
            setIsLoading(true);
            try {
                const response = await getComplianceFindingApiService().close(events.map((event) => event.id));
                setResults(response.data);
                req?.onSuccess?.(response.data);
            } catch (error: any) {
                setIsError(true);
                req?.onError?.(error?.message || 'An error occurred');
            } finally {
                setIsLoading(false);
            }
        },
        [req],
    );

    const reset = React.useCallback(() => {
        setIsLoading(false);
        setIsError(false);
        setResults(undefined);
    }, []);

    return {
        isLoading,
        isError,
        results,

        deleteEvents,
        reset,
    };
};
